<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar> </template>

    <!-- Set Appbar title-->
    <template #title>
      <v-toolbar-title class="font-weight-bold d-flex">
        Loan Pro
      </v-toolbar-title>
      <v-icon small style="margin-top: -20px">mdi-apps</v-icon>
      <ReportIssueButton />
      <NotificationMenu class="ml-10" />
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <NewLoanButton class="mr-6" />
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <router-view />
    </template>
  </ApplicationLayout>
</template>

<script>
import { mapActions } from 'vuex';
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import NewLoanButton from '../components/loan-pro/NewLoanButton.vue';
import NotificationMenu from '@/modules/shared/components/core/NotificationMenu.vue';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';
import CoreMixin from '@/mixins/core.mixin';
import SocketMixin from '@/modules/loanpro/mixins/socket.mixin';
import LoanStatisticService from '@/modules/loanpro/services/loan-statistic.service';

import loanproLinks from '@/modules/loanpro/routes/links';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: {
    ApplicationLayout,
    NotificationMenu,
    NewLoanButton,
    ReportIssueButton
  },
  mixins: [CoreMixin, SocketMixin],
  data: () => ({
    options: layoutOptions,
    links: loanproLinks,
    timeout: null
  }),

  async created() {
    this.updateBadgeCount();
  },

  async beforeMount() {
    await this.loadSettings();
  },

  destroyed() {
    clearTimeout(this.timeout);
  },

  methods: {
    ...mapActions('loanSettingsModule', ['loadSettings']),

    async updateBadgeCount() {
      this.timeout = setTimeout(async () => {
        const loanStatsService = new LoanStatisticService();
        const { data: badgeCountRes } =
          await loanStatsService.findWorkloadCount();
        console.log('GOT CALLED: ', badgeCountRes);
        this.links.forEach((e, index) => {
          if (e.id === 'workload') {
            let total = 0;
            const workloadChildren = e.items?.map((el) => {
              let count = badgeCountRes[el.id];
              total += count;

              el.badgeText = '0';
              el.badgeText = `${count}`;

              return el;
            });

            e.items = workloadChildren;
            e.badgeText = total || '0';
            this.links.splice(index, 1, e);
          }
        });
      }, 2000);
    }
  }
};
</script>
